import { render, staticRenderFns } from "./DrawingRequestShowCommentForm.vue?vue&type=template&id=578834be&scoped=true&"
import script from "./DrawingRequestShowCommentForm.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./DrawingRequestShowCommentForm.vue?vue&type=style&index=0&id=578834be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578834be",
  null
  
)

export default component.exports